import { getFirestore, collection, doc, getDoc, getDocs, updateDoc, deleteDoc, setDoc, query, where, orderBy, limit, startAfter, endBefore, onSnapshot } from "firebase/firestore";
import { getStorage, ref, uploadBytes, uploadString, getDownloadURL, deleteObject } from "firebase/storage";
import Vue from "vue";
import Axios from "axios";
import VueAxios from "vue-axios";
import { v4 as uuidv4 } from "uuid";

const db = getFirestore();
const storageInstance = getStorage();

const reactAppExercisesStorageVideos = ref(storageInstance, "reactAppExercisesVideos/");
const reactAppExercisesStorageImages = ref(storageInstance, "reactAppExercisesImages/");

const uniqueExercisesStorageVideos = ref(storageInstance, "uniqueExercisesVideos/");
const uniqueExercisesStorageImages = ref(storageInstance, "uniqueExercisesImages/");

// let start = null; 
// let end = null;
// let listeners = []
// let listExercises = []
export default {
  state: {
    exercises: [],
    exercisesModuleUnsubscribe: {},
    imageLoadingStatus: {
      imageAlex: 0,
      imageJustin: 0,
      imageShauna: 0,
      imageVeon: 0
    },
    videoLoadingStatus: {
      videoAlex: 0,
      videoJustin: 0,
      videoShauna: 0,
      videoVeon: 0
    },
    videoTrainerLoadingStatus: 0,
    imageTrainerLoadingStatus: 0,
    uniqueVideoLoadingStatus: 0,
    uniqueImageLoadingStatus: 0,
  },
  mutations: {
    SET_EXERCISES(state, exercises) {
      state.exercises = exercises;
    },
    SET_CONCAT_EXERCISES(state, exercisesNew) {
      state.exercises = state.exercises.concat(exercisesNew)
    },
    SET_UNSUBSCRIBE_EXERCISES_MODULE(state, unsubscribe) {
      Vue.set(
        state.exercisesModuleUnsubscribe,
        unsubscribe.type,
        unsubscribe.query
      );
    },
    GO_UNSUBSCRIBE_EXERCISES_MODULE(state, type) {
      state.exercisesModuleUnsubscribe[type]();
    },
    RESET_UNSUBSCRIBE_EXERCISES_MODULE(state) {
      state.exercisesModuleUnsubscribe = null;
    },
    SET_EXERCISE_VIDEO_LOADING_STATUS(state, loading) {
      Vue.set(
        state.videoLoadingStatus,
        loading.trainer,
        loading.status
      );
    },
    SET_EXERCISE_IMAGE_LOADING_STATUS(state, loading) {
      Vue.set(
        state.imageLoadingStatus,
        loading.trainer,
        loading.status
      );
    },
    SET_TRAINER_VIDEO_LOADING_STATUS(state, progress) {
      state.videoTrainerLoadingStatus = progress
    },
    SET_TRAINER_IMAGE_LOADING_STATUS(state, progress) {
      state.imageTrainerLoadingStatus = progress
    },
    SET_UNIQUE_VIDEO_LOADING_STATUS(state, progress) {
      state.uniqueVideoLoadingStatus = progress
    },
    SET_UNIQUE_IMAGE_LOADING_STATUS(state, progress) {
      state.uniqueImageLoadingStatus = progress
    },
    CLEAN_IMAGE_LOADING_STATUS(state) {
      state.imageLoadingStatus = {
        imageAlex: 0,
        imageJustin: 0,
        imageShauna: 0,
        imageVeon: 0
      }
    },
    CLEAN_VIDEO_LOADING_STATUS(state) {
      state.videoLoadingStatus = {
        videoAlex: 0,
        videoJustin: 0,
        videoShauna: 0,
        videoVeon: 0
      }
    }
  },
  actions: {
    async UpdateTwoHandsExercises() {
      return new Promise(async (resolve, reject) => {
        try {
          const querySnapshot = await getDocs(collection(db, 'excercisesNew'))
          let exercises = []
          for (let i = 0; i < querySnapshot.docs.length; i++) {
            let exercise = querySnapshot.docs[i].data();
            exercise.twoHands = true
            await setDoc(doc(db, 'excercisesNew', querySnapshot.docs[i].id), exercise)
            console.log('documents updated:', i + 1);
            exercises.push(exercise)
          }
          console.log(exercises);
          resolve(exercises)
        } catch (error) {
          reject(error)
        }
      })
    },
    async UpdateGrandFatheredExercises() {
      return new Promise(async (resolve, reject) => {
        try {
          const querySnapshot = await getDocs(collection(db, 'e'))
          let exercises = []
          for (let i = 0; i < querySnapshot.docs.length; i++) {
            let exercise = querySnapshot.docs[i].data();
            await updateDoc(doc(db, 'excercisesNew', querySnapshot.docs[i].id), { isGrandFathered: false })
            console.log('documents updated:', i + 1);
            exercises.push(exercise)
          }
        } catch (error) {
          console.log(error);
          reject(error)
        }
      })
    },
    GetBatchExercises({ commit }, options) {
      // console.log('asdads');

      let ref = collection(db, 'excercises')
      // single query to get startAt snapshot
      ref.orderBy('name.ENG', 'asc')
        // .startAt(start).endBefore(end)
        .limit(options.itemsPerPage)
        .onSnapshot((exercises) => {
          console.log('exercises', exercises);
          exercises.forEach((exercise) => {
            // exercises = listExercises.filter(x => x.id !== exercise.id)
            listExercises.push(exercise.data())
          })
          console.log(listExercises);
        })
    },
    QueryPassExercisesToNewCollection({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const querySnapshot = await getDocs(collection(db, "excercises"))
          const exercises = []
          let i = 0
          querySnapshot.forEach(async (doc) => {
            let exercise = doc.data();
            exercise.id = doc.id;
            // exercises.push(exercise)
            if (!exercise.trainersList) {
              exercise.isReactNativeExercise = true
              // console.log(`${exercise.name['ENG']}::::${exercise.id}`)
              await setDoc(doc(db, "excercisesNew", exercise.id), exercise)
              i++
              console.log(i);
            }

          })
          resolve(exercises)
        } catch (error) {
          reject(error)
        }
      })
    },
    UpdateVideosAndImagesExercises({ commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          const querySnapshot = await getDocs(query(collection(db, "excercisesNew"), where("enabled", "==", true)))
          const exercisesNewList = []
          let index = 0

          for (let i = 0; i < querySnapshot.docs.length; i++) {
            const doc = querySnapshot.docs[i];
            let exerciseNew = doc.data();
            exerciseNew.id = doc.id;
            exercisesNewList.push(exerciseNew)
            index++
            exerciseNew.trainersList = exerciseNew.trainersList ? exerciseNew.trainersList : []
            if (exerciseNew.imageAlex) {
              exerciseNew.trainersList.push({
                exImage: {
                  file: "jpeg",
                  link: exerciseNew.imageAlexLink,
                  ref: exerciseNew.imageAlex,
                  size: exerciseNew.imageAlexSize
                },
                exVideo: {
                  file: "mp4",
                  link: exerciseNew.videoAlexLink,
                  ref: exerciseNew.videoAlex,
                  size: exerciseNew.videoAlexSize
                },
                id: "3l53JJQVant4pmthfxtW",
                firstName: "Alex",
                lastName: "MaxPro"
              })
            }
            if (exerciseNew.imageJustin) {
              exerciseNew.trainersList.push({
                exImage: {
                  file: "jpeg",
                  link: exerciseNew.imageJustinLink,
                  ref: exerciseNew.imageJustin,
                  size: exerciseNew.imageJustinSize
                },
                exVideo: {
                  file: "mp4",
                  link: exerciseNew.videoJustinLink,
                  ref: exerciseNew.videoJustin,
                  size: exerciseNew.videoJustinSize
                },
                id: "KIxekMxUeDW4oFTq9QAx",
                firstName: "Justin",
                lastName: "MaxPro"
              })
            }
            if (exerciseNew.imageShauna) {
              exerciseNew.trainersList.push({
                exImage: {
                  file: "jpeg",
                  link: exerciseNew.imageShaunaLink,
                  ref: exerciseNew.imageShauna,
                  size: exerciseNew.imageShaunaSize
                },
                exVideo: {
                  file: "mp4",
                  link: exerciseNew.videoShaunaLink,
                  ref: exerciseNew.videoShauna,
                  size: exerciseNew.videoShaunaSize
                },
                id: "bZeUIPsD46aQQEyiLrzC",
                firstName: "Shauna",
                lastName: "MaxPro"
              })
            }
            if (exerciseNew.imageVeon) {
              exerciseNew.trainersList.push({
                exImage: {
                  file: "jpeg",
                  link: exerciseNew.imageVeonLink,
                  ref: exerciseNew.imageVeon,
                  size: exerciseNew.imageVeonSize
                },
                exVideo: {
                  file: "mp4",
                  link: exerciseNew.videoVeonLink,
                  ref: exerciseNew.videoVeon,
                  size: exerciseNew.videoVeonSize
                },
                id: "ETsQb742IZL5okmlUMuv",
                firstName: "Veon",
                lastName: "MaxPro"
              })
            }
            await updateDoc(doc(db, "excercisesNew", doc.id), { trainersList: exerciseNew.trainersList })
            console.log(index + ' Documents updated')
          }
          // commit('SET_CONCAT_EXERCISES', exercisesNewList)
          console.log(exercisesNewList);
          resolve(exercisesNewList)
        } catch (error) {
          reject(error)
        }
      })
    },
    async GetExercises({ commit }) {
      try {
        const querySnapshot = await getDocs(collection(db, "excercises"));

        let exercises = [];
        let i = 0
        querySnapshot.forEach((doc) => {
          let exercise = doc.data();
          exercise.id = doc.id;
          exercise.tableId = exercise.isReactNativeExercise ? `excercises-NewApp-${i}-${doc.id}` : `excercises-OldApp-${i}-${doc.id}`
          exercise.collectionName = 'excercises'
          exercises.push(exercise);
          i++
        });
        commit("SET_EXERCISES", exercises);
        return exercises;
      } catch (error) {
        console.error(error);
        return [];
      }
      
      // return new Promise((resolve, reject) => {

      //   getDocs(collection(db, "excercises"))
      //     .then((querySnapshot) => {
      //       let exercises = [];
      //       let i = 0
      //       querySnapshot.forEach((doc) => {
      //         let exercise = doc.data();
      //         exercise.id = doc.id;
      //         exercise.tableId = exercise.isReactNativeExercise ? `excercises-NewApp-${i}-${doc.id}` : `excercises-OldApp-${i}-${doc.id}`
      //         exercise.collectionName = 'excercises'
      //         exercises.push(exercise);
      //         i++
      //       });
      //       commit("SET_EXERCISES", exercises);
      //       resolve(exercises);
      //     }).catch((err) => {
      //       reject(err)
      //     })
      // });
    },
    async GetExercisesNew({ commit }) {
      try {
        const querySnapshot = await getDocs(collection(db, "excercisesNew"));
        const exercisesNewList = []
        let i = 0
        querySnapshot.forEach((doc) => {
          let exerciseNew = doc.data();
          exerciseNew.id = doc.id;
          exerciseNew.tableId = exerciseNew.isReactNativeExercise ? `excercisesNew-NewApp-${i}-${doc.id}` : `excercisesNew-OldApp-${i}-${doc.id}`
          exerciseNew.collectionName = 'excercisesNew'
          exercisesNewList.push(exerciseNew)
          i++
        })
        commit('SET_CONCAT_EXERCISES', exercisesNewList)
        return exercisesNewList;
      } catch (error) {
        console.error(error);
        return [];
      }
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     const querySnapshot = await getDocs(collection(db, "excercisesNew"))
      //     const exercisesNewList = []
      //     let i = 0
      //     querySnapshot.forEach((doc) => {
      //       let exerciseNew = doc.data();
      //       exerciseNew.id = doc.id;
      //       exerciseNew.tableId = exerciseNew.isReactNativeExercise ? `excercisesNew-NewApp-${i}-${doc.id}` : `excercisesNew-OldApp-${i}-${doc.id}`
      //       exerciseNew.collectionName = 'excercisesNew'
      //       exercisesNewList.push(exerciseNew)
      //       i++
      //     })
      //     commit('SET_CONCAT_EXERCISES', exercisesNewList)
      //     resolve(exercisesNewList)
      //   } catch (error) {
      //     reject(error)
      //   }
      // })
    },
    GetExercisesListPaginatedFirstPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {
        if (getters.getExercises.length > 0) {
          commit("GO_UNSUBSCRIBE_EXERCISES_MODULE", "exercise");
        }
        let getExercisesQuery = onSnapshot(query(collection(db, "excercises"), orderBy('name.ENG'), limit(itemsPerPage)), (querySnapshot) => {
          let exercises = [];
          querySnapshot.forEach((doc) => {
            let exercise = doc.data()
            exercise.id = doc.id;
            exercises.push(exercise);
          });
          commit("SET_EXERCISES", exercises);
          resolve(exercises);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_EXERCISES_MODULE", {
          type: "exercise",
          query: getExercisesQuery,
        })
      });
    },
    GetExercisesNextPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {
        commit("GO_UNSUBSCRIBE_EXERCISES_MODULE", "exercise");
        let getExercisesQuery = onSnapshot(query(collection(db, "excercises"), orderBy('name.ENG'), startAfter(getters.getExercises[getters.getExercises.length - 1].name['ENG']), limit(itemsPerPage)), (querySnapshot) => {
          let exercises = [];
          querySnapshot.forEach((doc) => {
            let exercise = doc.data()
            exercise.id = doc.id;
            exercises.push(exercise);
          });
          if (exercises.length > 0) {
            commit("SET_EXERCISES", exercises);
          }
          resolve(exercises);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_EXERCISES_MODULE", {
          type: "exercise",
          query: getExercisesQuery,
        })
      });
    },
    GetExercisesPrevPage({ commit, getters }, itemsPerPage) {
      return new Promise(async (resolve, reject) => {
        commit("GO_UNSUBSCRIBE_EXERCISES_MODULE", "exercise");
        let getExercisesQuery = onSnapshot(query(collection(db, "excercises"), orderBy('name.ENG', 'desc'), startAfter(getters.getExercises[0].name['ENG']), limit(itemsPerPage)), (querySnapshot) => {
          let exercises = [];
          querySnapshot.forEach((doc) => {
            let exercise = doc.data()
            exercise.id = doc.id;
            exercises.push(exercise);
          });
          commit("SET_EXERCISES", exercises);
          resolve(exercises);
        },
          (error) => {
            reject(error);
          }
        );
        commit("SET_UNSUBSCRIBE_EXERCISES_MODULE", {
          type: "exercise",
          query: getExercisesQuery,
        })
      });
    },
    GetExercise({ dispatch }, exerciseToGet) {
      return new Promise((resolve, reject) => {
        const collectionName = exerciseToGet.isReactNativeExercise ? 'excercisesNew' : 'excercises'
        const id = exerciseToGet.id
        getDoc(doc(db, collectionName, id)).then(async (doc) => {
          let exercise = doc.data()
          exercise.storageData = {}
          if (exercise.subscription && exercise.subscription != "") {
            let subscription = await getDoc(exercise.subscription)
            exercise.subscription = subscription.data()
          }
          let imagesAndVideos = [
            "imageAlex",
            "videoAlex",
            "imageJustin",
            "videoJustin",
            "imageShauna",
            "videoShauna",
            "imageVeon",
            "videoVeon",
          ];
          await imagesAndVideos.forEach((trainer) => {
            if (exercise[trainer] !== null) {
              dispatch("GetDownloadUrlRef", exercise[trainer]).then(async (url) => { Vue.set(exercise.storageData, trainer, url) })
            } else {
              exercise.storageData[trainer] = null
            }
          });
          resolve(exercise)
        }).catch((err) => {
          reject(err);
        })
      });
    },
    GoUnsubscribeExercisesModule({ commit }, type) {
      commit("GO_UNSUBSCRIBE_EXERCISES_MODULE", type);
    },
    async GetDownloadUrlRef({ }, link) {
      return await new Promise(async (resolve, reject) => {
        // console.log('linkkkk download url', link);
        if (link === null) {
          resolve(undefined);
        } else {
          await storageInstance.refFromURL(link).getDownloadURL()
            .then((downloadUrl) => {
              resolve(downloadUrl);
            });
        }
      });
    },
    DeleteExercise({ }, exercise) {
      return new Promise(async (resolve, reject) => {
        // this query does not delete storage file because exist two different collections with references to storage files and can be generate errors by deleted files
        const collectionName = exercise.isReactNativeExercise ? 'excercisesNew' : 'excercises'
        deleteDoc(doc(db, collectionName, exercise.id))
          .then((res) => {
            resolve(exercise.id);
          })
          .catch((err) => {
            reject(err);
          });

      })

    },
    DeleteExerciseFileStorage({ }, fileReference) {
      return new Promise(async (resolve, reject) => {
        let gsReference = ref(storageInstance, fileReference)
        await deleteObject(gsReference)
          .then(() => {
            resolve(true)
          }).catch((err) => {
            reject(err)
          })
      })

    },
    UploadVideoExercise({ commit }, videoExercise) {
      return new Promise(async (resolve, reject) => {
        try {
          let linkReference = `gs://maxfit-app.appspot.com/exercises-videos-notitle/${videoExercise.name}`
          let gsReference = ref(storageInstance, linkReference)

          // Upload the string
          await uploadString(gsReference, videoExercise.vid, "data_url");

          // Get the download URL
          const downloadURL = await getDownloadURL(gsReference);
          resolve({ link: downloadURL, ref: linkReference });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      })
    },
    UploadUniqueVideo({ commit }, video) {
      return new Promise(async (resolve, reject) => {
        try {
          let random = uuidv4();
          let storageRef = ref(storageInstance, `uniqueExercisesVideos/${random}`);

          console.log('storageRef', storageRef.name);
          console.log('video', video);
          let metadata = {
            contentType: 'video/mp4'
          }

          // Upload the string
          await uploadString(storageRef, video.vid, "data_url", metadata);

          // Get the download URL
          const downloadURL = await getDownloadURL(storageRef);
          commit('SET_UNIQUE_VIDEO_LOADING_STATUS', 0);
          resolve({ link: downloadURL, ref: random });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      });
    },
    UploadUniqueImage({ commit }, image) {
      return new Promise(async (resolve, reject) => {
        try {
          let random = uuidv4();
          let storageRef = ref(storageInstance, `uniqueExercisesImages/${random}`);

          console.log('storageRef', storageRef.name);
          console.log('image', image)

          // Upload the string
          await uploadString(storageRef, image.img, "data_url");

          // Get the download URL
          const downloadURL = await getDownloadURL(storageRef);
          commit('SET_UNIQUE_IMAGE_LOADING_STATUS', 0);
          resolve({ link: downloadURL, ref: random });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      });
    },
    UploadTrainerVideo({ commit }, videoTrainer) {
      return new Promise(async (resolve, reject) => {
        try {
          let random = uuidv4();
          let storageRef = ref(storageInstance, `reactAppExercisesVideos/${random}`);

          console.log('storageRef', storageRef.name);
          console.log('videoTrainer', videoTrainer);
          let metadata = {
            contentType: 'video/mp4'
          }

          // Upload the string
          await uploadString(storageRef, videoTrainer.video, "data_url", metadata);

          // Get the download URL
          const downloadURL = await getDownloadURL(storageRef);
          commit('SET_TRAINER_VIDEO_LOADING_STATUS', 0);
          resolve({ link: downloadURL, ref: random });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      });
    },
    UploadTrainerImage({ commit }, imageTrainer) {
      return new Promise(async (resolve, reject) => {
        try {
          let random = uuidv4();
          let storageRef = ref(storageInstance, `reactAppExercisesImages/${random}`);

          console.log('storageRef', storageRef.name);
          console.log('imageTrainer', imageTrainer)

          // Upload the string
          await uploadString(storageRef, imageTrainer.img, "data_url");

          // Get the download URL
          const downloadURL = await getDownloadURL(storageRef);
          commit('SET_TRAINER_IMAGE_LOADING_STATUS', 0);
          resolve({ link: downloadURL, ref: random });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      });
    },
    UploadImageExercise({ commit }, imageExercise) {
      return new Promise(async (resolve, reject) => {
        try {
          let linkReference = `gs://maxfit-app.appspot.com/exercises-images-notitle/${imageExercise.name}`
          let gsReference = ref(storageInstance, linkReference)

          // Upload the string
          await uploadString(gsReference, imageExercise.img, "data_url");

          // Get the download URL
          const downloadURL = await getDownloadURL(gsReference);
          resolve({ link: downloadURL, ref: linkReference });
        } catch (error) {
          console.log('error', error);
          reject(error);
        }
      })
    },
    async CreateExerciseNew({ }, exercise) {
      return new Promise(async (resolve, reject) => {
        if (exercise.subscription != "") {
          exercise.subscription = doc(db, "subscriptionsList", exercise.subscription.id)
        }
        const newDocRef = doc(collection(db, "excercisesNew"));
        exercise.id = newDocRef.id;
        exercise.createdAt = new Date()
        exercise.updatedAt = new Date()
        await setDoc(newDocRef, exercise)
          .then((res) => {
            resolve(newDocRef.id);
          })
          .catch((err) => {
            reject(err);
          });
      })
    },
    UpdateExercise({ }, exercise) {
      return new Promise(async (resolve, reject) => {
        if (exercise.storageData) {
          delete exercise.storageData
        }
        if (exercise.subscription && exercise.subscription != "") {
          exercise.subscription = doc(db, "subscriptionsList", exercise.subscription.id)
        }
        if (exercise.createdAt) {
          delete exercise.createdAt
        }
        exercise.updatedAt = new Date()
        const collectionName = exercise.isReactNativeExercise ? 'excercisesNew' : 'excercises'

        await updateDoc(doc(db, collectionName, exercise.id), exercise)
          .then((res) => {
            resolve(exercise.id);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    DisableExercise({ }, exercise) {
      return new Promise(async (resolve, reject) => {
        try {
          await updateDoc(doc(db, exercise.collectionName, exercise.id), {
            enabled: !exercise.enabled
          })
          resolve(exercise.id);
        } catch (error) {
          reject(error);
        }
      });

    },
    UpdateExerciseField({ }, exercise) {
      return new Promise(async (resolve, reject) => {
        try {
          await updateDoc(doc(db, exercise.collectionName, exercise.id), {
            [exercise.fieldName]: exercise.value
          })
          resolve(exercise.id);
        } catch (error) {
          reject(error);
        }
      });

    },
    CleanImageLoader({ commit }) {
      commit("CLEAN_IMAGE_LOADING_STATUS");
    },
    CleanVideoLoader({ commit }) {
      commit("CLEAN_VIDEO_LOADING_STATUS");
    }
  },
  getters: {
    getExercises(state) {
      return state.exercises;
    },
    getUploadVideoLoading(state) {
      return state.videoLoadingStatus;
    },
    getUploadImageLoading(state) {
      return state.imageLoadingStatus;
    },
    getVideoTrainerLoadingStatus(state) {
      return state.videoTrainerLoadingStatus;
    },
    getImageTrainerLoadingStatus(state) {
      return state.imageTrainerLoadingStatus;
    },
    getUploadUniqueVideoLoading(state) {
      return state.uniqueVideoLoadingStatus;
    },
    getUploadUniqueImageLoading(state) {
      return state.uniqueImageLoadingStatus;
    },
  },
};
